import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import Layout from "../../components/Layout";

import api, { apiCRMv3 } from "../../services/api";

import Swal from "sweetalert2";
import MultiselectTwoSides from "react-multiselect-two-sides";
import {
	R01,
	R02,
	R03,
	R04,
	R05,
	R06,
	R07,
	R08,
	R09,
	R10,
	R11,
	R12,
	R13,
	R14,
	R15,
} from "../../services/regionals";

const NotificationsCRMNew = (props) => {
	const [loaded, setLoaded] = useState(false);
	const [error, setError] = useState({});
	const [title, setTitle] = useState("");
	const [text, setText] = useState("");
	const [usersRaw, setUsersRaw] = useState([]);
	const [users, setUsers] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [branches, setBranches] = useState([]);

	useEffect(() => {
		const load = async () => {
			try {
				const usersResponse = await apiCRMv3.get("/user");
				setUsersRaw(usersResponse.data.data.data);
				const newUsers = await usersResponse.data.data.data.map(
					(user) => {
						return {
							value: user.id,
							label: `${user.branch.longCode} | ${user.name} - CPF: ${user.cpf} | ${user.branch.city.name}-${user.branch.city.state.abbreviation}`,
						};
					},
				);
				setUsers(newUsers);
				const branchesResponse = await apiCRMv3.get("/branch");
				setBranches(branchesResponse.data.data);
			} catch (error) {
			} finally {
				setLoaded(true);
			}
		};
		load();
	}, []);

	const stateSelected = (e, state) => {
		e.preventDefault();

		let usersByBranches = usersRaw
			.filter((user) => user.branch.city.state.abbreviation === state)
			.map((user) => user.id);

		// Cria um Set para eliminar duplicados
		const unique = new Set([...selectedUsers, ...usersByBranches]);

		setSelectedUsers(Array.from(unique));
	};

	const regionalSelected = (e, regional) => {
		e.preventDefault();

		const REGIONALS = {
			R01,
			R02,
			R03,
			R04,
			R05,
			R06,
			R07,
			R08,
			R09,
			R10,
			R11,
			R12,
			R13,
			R14,
			R15,
		};

		console.log(REGIONALS);

		const branches = REGIONALS[regional];
		if (!branches) return; // regional inválida, só sai

		// pega os IDs dos users que pertencem às filiais da regional
		const usersByBranches = usersRaw
			.filter((user) => branches.includes(user.branch.longCode))
			.map((user) => user.id);

		// evita duplicados usando Set e também evita race condition usando callback
		setSelectedUsers((prev) =>
			Array.from(new Set([...prev, ...usersByBranches])),
		);
	};

	const branchSelected = (e, branch) => {
		e.preventDefault();

		let usersByBranches = usersRaw
			.filter((user) => user.branch.longCode === branch)
			.map((user) => user.id);

		// Cria um Set para eliminar duplicados
		const unique = new Set([...selectedUsers, ...usersByBranches]);

		setSelectedUsers(Array.from(unique));
	};

	const handleChangeSelectedUsers = (value) => {
		setSelectedUsers(value);
	};

	function handleCancelButton(event) {
		Swal.fire({
			title: "Tem certeza que deseja cancelar?",
			text: "Cancelar fará você perder todas as modificações feitas até o momento!",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Sim, quero cancelar!",
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if (result.value) {
				Swal.fire(
					"Cancelado!",
					"Você irá voltar para a tela de dashboard.",
					"success",
				);

				props.history.push("/dashboard");
			}
		});
	}

	async function handleSubmitForm(event) {
		event.preventDefault();
		setLoaded(false);
		try {
			if (selectedUsers.length <= 0) {
				Swal.fire({
					type: "error",
					title: "Ops!",
					text: "Você não selecionou nenhum vendedor. É necessário selecionar pelo menos um vendedor!",
				});
				setLoaded(true);
				return;
			}
			console.log(selectedUsers);
			const createdNotification = await apiCRMv3.post("/notification", {
				title: title,
				text: text,
				additionalData: {
					screen: "Home",
					data: {},
				},
				users: selectedUsers,
			});
			setLoaded(true);
			if (createdNotification.status === 200) {
				setLoaded(true);
				Swal.fire({
					type: "success",
					title: "Salvo!",
					text: "A notificação foi disparada com sucesso!",
				}).then(() => props.history.push("/dashboard"));
			} else {
				Swal.fire({
					type: "error",
					title: "Oops...",
					text: "Tivemos um problema ao disparar essa notificação. Contate o suporte!",
				});
				setLoaded(true);
			}
		} catch (e) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "Tivemos um problema ao disparar essa notificação. Contate o suporte!",
			});
		} finally {
			setLoaded(true);
		}
	}

	return (
		<Layout
			menuActive="notifications-crm"
			pageTitle="Notificações - Nova Notificação"
		>
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<div className="card-header">
							<div className="card-title">
								Notificações - Nova Notificação
							</div>
						</div>
						<div
							className={`card-body ${loaded ? "" : "__loading"}`}
						>
							<div className="loader-container text-center">
								<div className="icon">
									<div className="sk-wave">
										<div className="sk-rect sk-rect1"></div>
										<div className="sk-rect sk-rect2"></div>
										<div className="sk-rect sk-rect3"></div>
										<div className="sk-rect sk-rect4"></div>
										<div className="sk-rect sk-rect5"></div>
									</div>
								</div>
								<div className="title">Carregando</div>
							</div>

							<form
								className="form form-horizontal"
								onSubmit={handleSubmitForm}
							>
								<div className="section">
									<div className="section-title">
										Informações Básicas
									</div>
									<div className="section-body">
										<div
											className={
												"form-group " +
												(error.name ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Título
											</label>
											<div className="col-md-9">
												<input
													type="text"
													className="form-control"
													placeholder=""
													value={title}
													maxLength={55}
													onChange={(event) => {
														setTitle(
															event.target.value,
														);
													}}
												/>
											</div>
										</div>
										<br />
										<div
											className={
												"form-group " +
												(error.name ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Texto
											</label>
											<div className="col-md-9">
												<input
													type="text"
													className="form-control"
													placeholder=""
													value={text}
													maxLength={145}
													onChange={(event) => {
														setText(
															event.target.value,
														);
													}}
												/>
											</div>
										</div>
										<br />
										<div className="form-group">
											<label className="col-md-3 control-label">
												Estados
											</label>
											<div className="col-md-9">
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "AC")
													}
												>
													AC
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "AL")
													}
												>
													AL
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "AP")
													}
												>
													AP
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "AM")
													}
												>
													AM
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "BA")
													}
												>
													BA
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "CE")
													}
												>
													CE
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "DF")
													}
												>
													DF
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "ES")
													}
												>
													ES
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "GO")
													}
												>
													GO
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "MA")
													}
												>
													MA
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "MT")
													}
												>
													MT
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "MS")
													}
												>
													MS
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "MG")
													}
												>
													MG
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "PA")
													}
												>
													PA
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "PB")
													}
												>
													PB
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "PR")
													}
												>
													PR
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "PE")
													}
												>
													PE
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "PI")
													}
												>
													PI
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "RJ")
													}
												>
													RJ
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "RN")
													}
												>
													RN
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "RS")
													}
												>
													RS
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "RO")
													}
												>
													RO
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "RR")
													}
												>
													RR
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "SC")
													}
												>
													SC
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "SP")
													}
												>
													SP
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "SE")
													}
												>
													SE
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														stateSelected(e, "TO")
													}
												>
													TO
												</button>
											</div>
										</div>

										<br />
										<div className="form-group">
											<label className="col-md-3 control-label">
												Regionais
											</label>
											<div className="col-md-9">
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R01",
														)
													}
												>
													R01
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R02",
														)
													}
												>
													R02
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R03",
														)
													}
												>
													R03
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R04",
														)
													}
												>
													R04
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R05",
														)
													}
												>
													R05
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R06",
														)
													}
												>
													R06
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R07",
														)
													}
												>
													R07
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R08",
														)
													}
												>
													R08
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R09",
														)
													}
												>
													R09
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R10",
														)
													}
												>
													R10
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R11",
														)
													}
												>
													R11
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R12",
														)
													}
												>
													R12
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R13",
														)
													}
												>
													R13
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R14",
														)
													}
												>
													R14
												</button>
												<button
													className="btn btn-primary"
													style={{
														marginLeft: 10,
													}}
													onClick={(e) =>
														regionalSelected(
															e,
															"R15",
														)
													}
												>
													R15
												</button>
											</div>
										</div>
										<br />
										<div className="form-group">
											<label className="col-md-3 control-label">
												Filiais
											</label>
											<div className="col-md-9">
												{branches.map(
													(branch, index) => (
														<button
															key={index}
															className="btn btn-primary"
															style={{
																marginLeft: 10,
															}}
															onClick={(e) =>
																branchSelected(
																	e,
																	branch.longCode,
																)
															}
														>
															{branch.longCode}
														</button>
													),
												)}
											</div>
										</div>
										<div className="col-md-offset-3 col-md-9">
											<div
												className="alert alert-warning"
												role="alert"
											>
												Para filtrar por estado, basta
												utilizar, por exemplo: "-PR" ou
												"-GO" e clicar na seta para
												enviar todas as filiais
												filtradas do lado esquerdo para
												o direito
											</div>
										</div>
										<div className="form-group">
											<label className="col-md-3 control-label">
												Usuários
											</label>
											<div className="col-md-9">
												<MultiselectTwoSides
													options={users}
													value={selectedUsers}
													className="msts_theme_example"
													onChange={
														handleChangeSelectedUsers
													}
													availableHeader="Disponíveis"
													availableFooter={`Disponíveis: ${
														users.length -
														selectedUsers.length
													}`}
													selectedHeader="Selecionadas"
													selectedFooter={`Selecionadas: ${selectedUsers.length}`}
													labelKey="label"
													showControls
													searchable
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="form-footer">
									<div className="form-group">
										<div className="col-md-9 col-md-offset-3">
											<button
												type="submit"
												className="btn btn-primary"
											>
												Enviar
											</button>
											<button
												type="button"
												onClick={handleCancelButton}
												className="btn btn-default"
											>
												Cancelar
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default withRouter(NotificationsCRMNew);
